import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-270c1fd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal" }
const _hoisted_2 = { class: "modal__container" }
const _hoisted_3 = { class: "modal__header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Comprovante do pedido", -1))
const _hoisted_5 = { class: "modal__information" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "modal__title" }, "Pedido finalizado com sucesso!", -1))
const _hoisted_7 = { class: "modal__subTitle" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Enviamos para seu email ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" mais detalhes do seu pedido. ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Você também pode acompanhar seu pedido ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" clicando aqui. ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Em caso de dúvida, você pode enviar um e-mail para ")
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Lembre-se, o que tem maior valor é o seu aprendizado! ", -1))
const _hoisted_16 = { class: "modal__receipt" }
const _hoisted_17 = { class: "modal__order" }
const _hoisted_18 = { class: "modal__total" }
const _hoisted_19 = { class: "modal__texts" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Total de produtos:", -1))
const _hoisted_21 = { class: "modal__texts" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Valor total:", -1))
const _hoisted_23 = { class: "modal__products" }
const _hoisted_24 = { class: "image_limiter" }
const _hoisted_25 = { class: "modal__text-product" }
const _hoisted_26 = { class: "modal__title-product" }
const _hoisted_27 = { class: "modal__title-product" }
const _hoisted_28 = { class: "modal__values" }
const _hoisted_29 = { class: "modal__footer" }
const _hoisted_30 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_HoverGallery = _resolveComponent("HoverGallery")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("button", {
          type: "button",
          class: "modal__button-close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.close()))
        })
      ]),
      _createElementVNode("section", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          ($setup.user.email)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("span", null, _toDisplayString($setup.user.email), 1),
                _hoisted_10
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("p", null, [
            _hoisted_11,
            _createVNode(_component_router_link, { to: { name: 'profile', params: { option: 'history-order' } } }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }),
            _hoisted_13,
            _createElementVNode("a", {
              href: `malito:` + $setup.email
            }, _toDisplayString($setup.email) + ".", 9, _hoisted_14)
          ]),
          _hoisted_15
        ]),
        _createElementVNode("section", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("h5", null, "Pedido #" + _toDisplayString($setup.receipt.id), 1),
            _createElementVNode("h5", null, "Data: " + _toDisplayString($setup.formattedDate($setup.receipt.createAt)), 1)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("h5", null, _toDisplayString($setup.receipt.quantity), 1)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("h5", null, _toDisplayString($setup.receipt.grossValue) + " decoins", 1)
            ])
          ])
        ]),
        _createElementVNode("section", _hoisted_23, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.receipt.products, (product, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "modal__cards",
              key: index
            }, [
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_HoverGallery, {
                  gallery: product.imagesUrl
                }, null, 8, ["gallery"])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("h5", null, _toDisplayString(product.name), 1),
                  _createElementVNode("span", null, _toDisplayString(product.shop.name), 1)
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("h5", null, "Qtde: " + _toDisplayString(product.quantity), 1),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("h5", null, "Valor unit. " + _toDisplayString(product.decoins) + " decoins", 1),
                    _createElementVNode("h5", null, "Valor total " + _toDisplayString($setup.amount(product)) + " decoins", 1)
                  ])
                ])
              ])
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("footer", _hoisted_29, [
        _createElementVNode("a", {
          class: "modal__button-receipt",
          href: $setup.receipt.receiptUrl,
          target: "_blank",
          download: ""
        }, " Baixar comprovante ", 8, _hoisted_30)
      ])
    ])
  ], 512)), [
    [_vShow, $setup.modalOpened]
  ])
}